import { render, staticRenderFns } from "./CreateOrion.vue?vue&type=template&id=7ff17b74&scoped=true&"
import script from "./CreateOrion.vue?vue&type=script&lang=js&"
export * from "./CreateOrion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff17b74",
  null
  
)

export default component.exports